<template>
    <div class="submission-container">
        <a-table size="small" :pagination="false" :rowClassName="genRowClass"
            :columns="columns" :data-source="data" rowKey="id"
        >
            <verdict-icon slot="verify" slot-scope="verify" :verify="verify" />
            <templated-username slot="user" slot-scope="user" :user="user"></templated-username>
            <span slot="timestamp" slot-scope="timestamp">{{ formatDate(timestamp)}}</span>
            <span slot="manage" slot-scope="record">
                <a-button type="danger" size="small"
                    :disabled="Number(record.verify) === -1" 
                    @click="deleteSubmission(record)"
                ><a-icon type="delete" /></a-button>
            </span>
            <span slot="footer" v-if="!hasFetchAll" class="footer">
                <a-button size="small" type="link"
                    :loading="loading" @click="loadMore"
                >加载更多</a-button>
            </span>
        </a-table>
    </div>
</template>

<script>
import VerdictIcon from '@/components/VerdictIcon.vue'
import TemplatedUsername from '@/components/TemplatedUsername.vue';
import { mapState } from 'vuex';
import { formatTime } from '../../../utils/utils';

export default {
    props: {
        submissions: Array,
        difficultyLabel: String,
        name: String,
        hasFetchAll: Boolean, 
        verifiedOnly: Boolean,
    },
    data: () => ({
        loading: false,
    }),
    inject: {
        app: 'app',
        record: 'record',
    },
    computed: {
        ...mapState({ userid: 'userid' }),
        data() {
            return this.submissions.map((e, i) => ({ ...e, rank: i+1 }));
        },
        columns() {
            const cols = [
                { dataIndex: 'verify', slot: 'verify' },
                { title: '#', dataIndex: 'rank' },
                { title: '用户名', dataIndex: 'user', slot: 'user' },
                { title: '分数', dataIndex: 'score' },
                { title: '游戏时间', dataIndex: 'totalTime' },
                { title: '提交时间', dataIndex: 'timestamp', slot: 'timestamp' },
            ];
            if (this.record.manageMode) {
                cols.push({
                    title: '管理', slot: 'manage'
                })
            }
            return cols.map(e => e.slot ?
                { ...e, scopedSlots: { customRender: e.slot } } : e
            );
        }
    },
    methods: {
        formatDate(timestamp) {
            return formatTime(timestamp, {
                day: "HH:mm:ss",
                year: "MM/DD HH:mm:ss",
                other: "YYYY/MM/DD HH:mm:ss"
            });
        },
        async loadMore() {
            this.loading = true;
            await this.record.loadMore(this.difficultyLabel, this.name, this.submissions.length * 2,this.varifiedOnly);
            this.loading = false;
        },
        genRowClass(row) {
            if (row.user.id < 0 || row.user.id != this.userid) return '';
            return 'my-submission';
        },
        async deleteSubmission(record) {
            this.$confirm({
                title: `确认要删除 ${ record.user.name } 的提交吗？`,
                onOk: async() => {
                    this.loading = true;
                    try {
                        await this.record.deleteSubmission(record.id);
                        await this.record.loadMore(this.difficultyLabel, this.name, this.submissions.length);
                    } finally {
                        this.loading = false;
                    }
                },
                onCancel() {
                    //
                },
            });
        }
    },
    components: {
        VerdictIcon,
        TemplatedUsername,
    }
}
</script>

<style lang="less" scoped>
.footer {
    text-align: center;
    margin: auto;
    display: block;
}
.submission-container {
    overflow: auto;
}
</style>

<style scoped>
.submission-container >>> .my-submission {
    background-color: #E0F2F1;
}
</style>